import * as style from './style.css';
import React = require('react');

interface ITemplateProps {
    content: React.ReactElement;
    header: string;
    thumbnail:string;
}
export default function ProductModalTemplate(props: ITemplateProps) {
    return <div className={style.wrapper}>
        <div className={style.header}>
            {props.header}
        </div>
        <div className={style.content}>
            <div className={style.thumbnail}>
                {props.thumbnail && <img src={props.thumbnail} />}
            </div>
            <div className={style.text}>
                {props.content}
            </div>
        </div>
    </div>
    ;
}
